var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.273 0H11.727C5.2605 0 0 5.3835 0 12C0 18.6165 5.2605 24 11.727 24C16.131 24 19.959 21.726 21.9435 18H26.055C28.0395 21.726 31.8675 24 36.2715 24C42.7395 24 48 18.6165 48 12C48 5.3835 42.7395 0 36.273 0ZM16.5 13.5H13.5V16.5H10.5V13.5H7.5V10.5H10.5V7.5H13.5V10.5H16.5V13.5ZM34.5 16.5C33.672 16.5 33 15.828 33 15C33 14.172 33.672 13.5 34.5 13.5C35.328 13.5 36 14.172 36 15C36 15.828 35.328 16.5 34.5 16.5ZM39 12C38.172 12 37.5 11.328 37.5 10.5C37.5 9.672 38.172 9 39 9C39.828 9 40.5 9.672 40.5 10.5C40.5 11.328 39.828 12 39 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon2);
export default __webpack_public_path__ + "static/media/why-icon2.e796678e1ce92b2468a530ddef3ff21a.svg";
export { ForwardRef as ReactComponent };